/* eslint-disable max-len */

import { useTranslation } from 'react-i18next';
import { CustomError, ManageOrderCodeLabelColumn } from '../../../../components';
import { weathering } from '../../../../entityModel';
import {
  TXT_DATA_NOT_FOUND,
  TXT_DELETE,
  TXT_EDIT,
  TXT_LOADING
} from '../../../../translations/translationConstants';
import { capitalizeFirstLetter } from '../../../../shared/stringFunctions';
import { getWeatheringOutput } from '../../../../api';
import { ApolloError } from '@apollo/client';

export interface ManageWeatheringsTableBodyProps {
  error?: ApolloError;
  loading: boolean;
  data?: getWeatheringOutput;
  columns: ManageOrderCodeLabelColumn[];
  onEdit: (weathering: weathering) => void;
  onDelete: (weathering: weathering) => void;
}

export const ManageWeatheringsTableBody =
  ({ error, columns, loading, data, onEdit, onDelete }: ManageWeatheringsTableBodyProps) => {
    const { t } = useTranslation();
    return (
      <tbody>
        {
          loading &&
          <tr>
            <td colSpan={columns.length} style={{ textAlign: 'center' }}>
              <h3>
                {t(TXT_LOADING).toUpperCase()}
              </h3>
            </td>
          </tr>
        }
        {
          !loading && error && error.message &&
          <tr>
            <td colSpan={columns.length}>
              <CustomError>
                {error.message}
              </CustomError>
            </td>
          </tr>
        }
        {
          !loading && data &&
          data.weathering && data.weathering.items &&
          data.weathering.items.length > 0 &&
          data.weathering.items.map((weathering) => (
            <tr key={`row-${weathering.id}`}>
              <td>
                {weathering.order}
              </td>
              <td>
                {weathering.code}
              </td>
              <td>
                {weathering.label}
              </td>
              <td align='center'>
                <button
                  data-target="#modal-weathering-editor"
                  data-toggle="modal"
                  className='btn btn-primary'
                  aria-label="edit weathering"
                  onClick={() => onEdit(weathering)}>
                  {t(TXT_EDIT).toUpperCase()}
                </button>
              </td>
              <td align='center'>
                <button
                  data-target="#modal-default"
                  data-toggle="modal"
                  className='btn btn-danger'
                  aria-label="delete weathering"
                  type="button"
                  onClick={() => onDelete(weathering)}>
                  {t(TXT_DELETE).toUpperCase()}
                </button>
              </td>
            </tr>
          ))
        }
        {
          !loading &&
          (!data ||
            !data.weathering ||
            !data.weathering.items ||
            data.weathering.items.length <= 0) &&
          <tr>
            <td colSpan={columns.length}>
              <CustomError>
                {capitalizeFirstLetter(t(TXT_DATA_NOT_FOUND))}
              </CustomError>
            </td>
          </tr>
        }
      </tbody>
    );
  };
